import { InjectionToken } from '@angular/core';
import { NullListDataProvider } from '../defaults/null-list-data-provider';

/**
 * Interface für List-Daten Provider
 * Abstrahiert den Zugriff auf Lookup-Tabellen für Select-Listen
 */
export interface IListDataProvider {
	/**
	 * Holt hardcodierte Lookup-Daten
	 */
	getHardcoded(tableName: string): any[];

	/**
	 * Holt Tabellendaten aus einer externen Quelle (z.B. MDB)
	 */
	getTable(tableName: string): any[];
}

export const LIST_DATA_PROVIDER = new InjectionToken<IListDataProvider>('LIST_DATA_PROVIDER', {
	providedIn: 'root',
	factory: () => new NullListDataProvider()
});
